import { render, staticRenderFns } from "./InstrumentInfo.vue?vue&type=template&id=4a51c5c3&scoped=true&"
import script from "./InstrumentInfo.vue?vue&type=script&lang=js&"
export * from "./InstrumentInfo.vue?vue&type=script&lang=js&"
import style0 from "./InstrumentInfo.vue?vue&type=style&index=0&id=4a51c5c3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a51c5c3",
  null
  
)

export default component.exports